// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .optin-card {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 2rem;
    margin: 1rem auto;
    border-radius: 16px;
    width: 100%;
    max-width: 480px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
  }
  
  .optin-card h2 {
    font-size: 1.8rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 1rem;
  }
  
  .optin-card form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .optin-card label {
    display: block;
    font-size: 0.95rem;
    margin-bottom: 0.25rem;
  }
  
  .optin-card input[type='tel'],
  .optin-card input[type='email'] {
    width: 100%;
    padding: 0.5rem;
    border-radius: 8px;
    border: none;
    font-size: 1rem;
  }
  
  .optin-card input[type='checkbox'] {
    margin-right: 0.5rem;
  }
  
  .optin-card a {
    color: #4dd1ff;
    text-decoration: underline;
  }
  
  .optin-card .google-prompt {
    font-weight: 600;
    color: #81b3ff;
    margin-top: 1rem;
  }
  
  .optin-card button[type='submit'] {
    background-color: #ffd700;
    color: #000;
    font-weight: bold;
    padding: 0.75rem;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    transition: background 0.3s ease;
  }
  
  .optin-card button[type='submit']:hover {
    background-color: #f5c400;
  }
  
  .optin-card .error {
    color: #ff8080;
    text-align: center;
  }
  `, "",{"version":3,"sources":["webpack://./src/optin/OptInPage.css"],"names":[],"mappings":";;EAEE;IACE,4DAA4D;IAC5D,WAAW;IACX,oCAAoC;IACpC,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB","sourcesContent":["\n  \n  .optin-card {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    color: #fff;\n    background-color: rgba(0, 0, 0, 0.6);\n    padding: 2rem;\n    margin: 1rem auto;\n    border-radius: 16px;\n    width: 100%;\n    max-width: 480px;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);\n  }\n  \n  .optin-card h2 {\n    font-size: 1.8rem;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 1rem;\n  }\n  \n  .optin-card form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .optin-card label {\n    display: block;\n    font-size: 0.95rem;\n    margin-bottom: 0.25rem;\n  }\n  \n  .optin-card input[type='tel'],\n  .optin-card input[type='email'] {\n    width: 100%;\n    padding: 0.5rem;\n    border-radius: 8px;\n    border: none;\n    font-size: 1rem;\n  }\n  \n  .optin-card input[type='checkbox'] {\n    margin-right: 0.5rem;\n  }\n  \n  .optin-card a {\n    color: #4dd1ff;\n    text-decoration: underline;\n  }\n  \n  .optin-card .google-prompt {\n    font-weight: 600;\n    color: #81b3ff;\n    margin-top: 1rem;\n  }\n  \n  .optin-card button[type='submit'] {\n    background-color: #ffd700;\n    color: #000;\n    font-weight: bold;\n    padding: 0.75rem;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    transition: background 0.3s ease;\n  }\n  \n  .optin-card button[type='submit']:hover {\n    background-color: #f5c400;\n  }\n  \n  .optin-card .error {\n    color: #ff8080;\n    text-align: center;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
